import { Chip } from '@/shared/ui/chip.tsx'
import { maxReminderDay, reminderPresets } from '../reminders.ts'

interface ReminderPickerProps {
  value: string | null
  today: string
  onChange: (day: string | null) => void
  disabled?: boolean
}

/** One tap for the usual «через неделю / месяц / два», a date field for anything else. */
export function ReminderPicker({ value, today, onChange, disabled = false }: ReminderPickerProps) {
  const presets = reminderPresets(today)

  return (
    <fieldset disabled={disabled} className="flex flex-wrap items-center gap-1.5 disabled:opacity-60">
      <legend className="sr-only">Когда напомнить</legend>
      {presets.map((preset) => (
        <Chip
          key={preset.label}
          label={preset.label}
          active={value === preset.day}
          onClick={() => onChange(value === preset.day ? null : preset.day)}
        />
      ))}
      <input
        type="date"
        aria-label="Дата напоминания"
        value={value ?? ''}
        min={today}
        max={maxReminderDay(today)}
        onChange={(event) => onChange(event.target.value || null)}
        className="h-[34px] rounded-full border border-line bg-surface px-3 text-[13px] text-neutral-ink outline-none focus:border-brand max-sm:min-h-11 max-sm:w-full"
      />
    </fieldset>
  )
}
